import Typography from "@mui/material/Typography";
import { FC } from "react";
import FlexCenter from "shared/components/Layout/components/FlexCenter";
import { COLOR_GREY_10 } from "shared/theme/colors";
import { StyledButton, StyledFooter } from "./styled";

type ComboFooterProps = {
  onClearAll: () => void;
  selectedCount: number;
  totalAmount: number;
};

const ComboFooter: FC<ComboFooterProps> = ({
  onClearAll,
  totalAmount,
  selectedCount,
}) => {
  return (
    <StyledFooter
      onClick={(e) => {
        e.stopPropagation();
      }}
    >
      <StyledButton
        color="info"
        onClick={(e) => {
          e.stopPropagation();
          onClearAll();
        }}
      >
        Clear all
      </StyledButton>
      <FlexCenter margin="0 1rem">
        <Typography variant="bodySMedium" color={COLOR_GREY_10}>
          {selectedCount} of {totalAmount}
        </Typography>
      </FlexCenter>
    </StyledFooter>
  );
};

export default ComboFooter;
